<div class="row action-toolbar" style="margin-top: 20px">
    <div class="col-12">
        <div class="form-inline">
            <action-toolbar-search name="chargeSearch" [ngModel]="searchText" (ngModelChange)="onSearchChanged($event)"></action-toolbar-search>

            <div class="input-header-group">
                <span class="input-header">Job</span>
                <wj-auto-complete
                    [(ngModel)]="job"
                    name="chargeJob"
                    [isRequired]="false"
                    style="width: 340px"
                    (ngModelChange)="jobChanged($event)"
                    [maxItems]="100"
                    [itemsSource]="jobOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-auto-complete>
            </div>

            <div class="input-header-group">
                <span
                    class="input-header"
                    title="HeavyBid bid number. Versions such as 26060BUDGET are included under 26060. Choosing an estimate selects its Vista job, and choosing a job selects its bid number."
                    >Estimate</span
                >
                <wj-auto-complete
                    [(ngModel)]="estimateCode"
                    name="chargeEstimate"
                    [isRequired]="false"
                    style="width: 300px"
                    (ngModelChange)="estimateChanged($event)"
                    [maxItems]="100"
                    [itemsSource]="estimateOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-auto-complete>
            </div>

            <div class="input-header-group">
                <span class="input-header">Tax %</span>
                <input class="form-control" style="width: 90px" type="number" step="any" name="chargeTax" [(ngModel)]="taxPercent" />
            </div>

            <div class="input-header-group">
                <span class="input-header">WC %</span>
                <input class="form-control" style="width: 90px" type="number" step="any" name="chargeWc" [(ngModel)]="wcPercent" />
            </div>

            <div class="input-header-group">
                <span class="input-header">Fringe $</span>
                <input class="form-control" style="width: 90px" type="number" step="any" name="chargeFringe" [(ngModel)]="fringe" />
            </div>

            <div class="input-header-group">
                <span class="input-header" title="Fringe dollars per hour for labor codes that start with OP.">OP Fringe $</span>
                <input class="form-control" style="width: 90px" type="number" step="any" name="chargeOpFringe" [(ngModel)]="opFringe" />
            </div>

            <button type="button" class="btn btn-primary btn-sm" (click)="load()" [disabled]="loading">Load</button>
            <grid-export [grids]="[laborFlex, equipmentFlex]" [name]="'Job Charge Rates.xlsx'" [names]="['Labor', 'Equipment']"></grid-export>
        </div>
    </div>
</div>

@if (loadError) {
    <p class="text-danger mt-2">{{ loadError }}</p>
}

<p class="text-muted mt-3 mb-2">
    Labor total is the 50-hour rate (base times the HeavyBid overtime percent) plus tax, fringe, and workers comp. HB Cost/Hr is HeavyBid's
    combined cost per hour. Equipment total is rent (ownership) plus EOE (operating, including fuel). The Vista category drops the leading 8 and
    letters from the HeavyBid code.
</p>

@if (jobLabel) {
    <p class="mb-2"><strong>{{ jobLabel }}</strong></p>
}

<h5 class="mt-3 mb-1">Labor</h5>
<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="laborGrid"></action-toolbar-count>
        </form>
    </div>
</div>
<wj-flex-grid
    #laborFlex
    id="jobChargeLaborGrid"
    style="height: 420px"
    [isReadOnly]="true"
    [frozenColumns]="1"
    (initialized)="laborGrid.initialize(laborFlex)"
    (destroy)="laborGrid.destroy()"
    [itemsSource]="laborGrid.view"
>
    <wj-flex-grid-filter></wj-flex-grid-filter>
    <wj-flex-grid-column [header]="'Code'" [binding]="'code'" [width]="110"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Desc'" [binding]="'description'" [width]="240"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Base'" [binding]="'baseRate'" [width]="100" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'OT %'" [binding]="'otPercent'" [width]="90" [format]="'n2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'50-Hr Rate'" [binding]="'rate50'" [width]="120" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Tax'" [binding]="'tax'" [width]="100" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Fringe'" [binding]="'fringe'" [width]="100" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'WC'" [binding]="'workersComp'" [width]="100" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Total'" [binding]="'total'" [width]="110" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'HB Cost/Hr'" [binding]="'hbCostPerHour'" [width]="120" [format]="'c2'"></wj-flex-grid-column>
</wj-flex-grid>
<grid-selection-calculation [grid]="laborFlex"></grid-selection-calculation>

<h5 class="mt-4 mb-1">Equipment</h5>
<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="equipmentGrid"></action-toolbar-count>
        </form>
    </div>
</div>
<wj-flex-grid
    #equipmentFlex
    id="jobChargeEquipmentGrid"
    style="height: 420px"
    [isReadOnly]="true"
    [frozenColumns]="1"
    (initialized)="equipmentGrid.initialize(equipmentFlex)"
    (destroy)="equipmentGrid.destroy()"
    [itemsSource]="equipmentGrid.view"
>
    <wj-flex-grid-filter></wj-flex-grid-filter>
    <wj-flex-grid-column [header]="'HB Code'" [binding]="'code'" [width]="140"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Vista Category'" [binding]="'vistaCategory'" [width]="140"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Desc'" [binding]="'description'" [width]="240"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Unit'" [binding]="'unit'" [width]="80"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Operator'" [binding]="'operatorCode'" [width]="110"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Rent'" [binding]="'rent'" [width]="100" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'EOE'" [binding]="'eoe'" [width]="100" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Total'" [binding]="'total'" [width]="110" [format]="'c2'"></wj-flex-grid-column>
</wj-flex-grid>
<grid-selection-calculation [grid]="equipmentFlex"></grid-selection-calculation>
